import React from 'react';

import { Container, Row, Col } from '@crehana/ui/dist/GridV2';
import Slider from '@crehana/ui/dist/Slider';
import { useTranslation } from '@crehana/i18n';

import { ProfessorsSectionProps } from './types';
import { ProfessorsSectionItem } from './components';

const ProfessorsSection: React.FC<
  React.PropsWithChildren<ProfessorsSectionProps>
> = ({ professors }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="absolute bg-gray-lighter w-full h-360 left-0 right-0 -z-1" />
      <section className="py-40 sm:py-64">
        <Container>
          <Row>
            <Col offset={{ lg: 1 }} lg={10}>
              <div className="sm:flex sm:justify-between sm:items-center lg:block mb-40 sm:mb-72">
                <h2 className="font-h2 text-center sm:text-left sm:w-6/12 lg:w-auto lg:text-center">
                  <span className="text-primary-main">
                    {`${t('PROFESSOR_SECTION_HIGHLIGHT_TITLE')} `}
                  </span>
                  {t('PROFESSOR_SECTION_TITLE')}
                </h2>
                <div className="hidden sm:block">
                  <div className="default-pagination-professors" />
                </div>
              </div>
              <Slider
                desktopPaginationSelector=".default-pagination-professors"
                itemsWithShadow
                itemsPerPage={{
                  lg: 4,
                  md: 3,
                  sm: 2,
                  xs: 1,
                }}
              >
                {professors.map(professor => (
                  <ProfessorsSectionItem
                    key={professor.id}
                    professor={professor}
                  />
                ))}
              </Slider>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ProfessorsSection;
